import Component from "../../lib/component";
import ComponentEvent from "../../lib/component_event";

export const SelecterItemConfig = {
    componentTypeKey: 'SelecterItem',
    baseHtmlClass: 'selector__item',
    selector: '.selector__item',

    contentSelector: '.selector__item__content',
    inputSelector: '.selector__item__input input[type="checkbox"], .selector__item__input input[type="radio"]',

    changedEventName: 'Rankers.SelecterItem:Changed',

    itemLabelSelector: '.selecter_item_label',
};

export class SelecterItem extends Component {

    constructor(id_or_element, selecter) {
        super({
            element: id_or_element,
            config: SelecterItemConfig
        });

        this.selecter = selecter;

        this.inputElement = this.element.querySelector(SelecterItemConfig.inputSelector);
        if (this.inputElement) {
            this.inputElement.addEventListener('change', this.handleInputChange.bind(this));
        }
    }

    handleInputChange(event) {
        const componentEvent = new ComponentEvent(SelecterItemConfig.changedEventName, {target: this});
        this.selecter.fireEvent(componentEvent);
    }

    render() {
        if (this.inputElement) this.conditionallySetHtmlClassState(this.isSelected(), 'selected');
        this.swapHtmlClassStates(this.matchesSearchQuery(this.getSearchQuery()), 'matched', 'unmatched');
    }

    isSelected() {
        if (!this.inputElement) return false;
        return this.inputElement.checked;
    }

    getSearchContent() {
        const contentElement = this.element.querySelector(SelecterItemConfig.contentSelector);
        const searchContent = (!!contentElement) ? contentElement.textContent : '';
        return searchContent;
    }

    matchesSearchQuery(query) {
        if (query === null || query === '') return true;
        const re = new RegExp(query, "i");
        return re.test(this.getSearchContent());
    }

    getSearchQuery() {
        return this.selecter.getSearchQuery();
    }

    getLabelHtml() {
        // When there's a item label element already then we provide that HTML…
        let labelElement = this.element.querySelector(SelecterItemConfig.itemLabelSelector);
        if (labelElement) return labelElement.outerHTML;

        // …otherwise we prepare HTML from the content element.
        let contentElement = this.element.querySelector(SelecterItemConfig.contentSelector);
        if (!contentElement) return `<div class="${SelecterItemConfig.itemLabelSelector}">Unknown item</div>`;;
        return `<div class="${SelecterItemConfig.itemLabelSelector}">${ contentElement.firstElementChild.outerHTML }</div>`;
    }

}

